import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { FacebookLogo, InstagramLogo, WhatsappLogo, XLogo, Copy } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StoryPublic() {
  const { token } = useParams();
  const [story, setStory] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/public/stories/${token}`)
      .then((r) => setStory(r.data))
      .catch(() => setError("This story is no longer available."));
  }, [token]);

  const url = typeof window !== "undefined" ? window.location.href : "";
  const text = story ? `${story.caption || story.headline}\n\n${(story.hashtags || []).join(" ")}` : "";

  return (
    <div className="min-h-screen bg-[#0F172A] px-4 py-10" data-testid="story-public-page">
      <div className="mx-auto max-w-md">
        <div className="font-display text-lg font-bold tracking-tight text-white">UNITY &amp; UTILITY</div>
        {error && <p className="mt-6 text-sm text-[#FF6B60]" data-testid="story-error">{error}</p>}
        {story && (
          <>
            {story.card_image_id && (
              <img
                src={`${API}/public/story-card/${token}`}
                alt={story.headline}
                className="mt-4 w-full border border-slate-700"
                data-testid="story-public-image"
              />
            )}
            <h1 className="mt-5 font-display text-2xl font-bold text-white" data-testid="story-public-headline">
              {story.headline}
            </h1>
            {story.price_label && (
              <div className="mt-2 inline-block bg-[#002FA7] px-3 py-1 font-mono text-lg font-bold text-white" data-testid="story-public-price">
                {story.price_label}
              </div>
            )}
            {story.subline && <p className="mt-3 text-sm text-slate-300">{story.subline}</p>}
            <p className="mt-3 text-xs text-slate-400">
              {story.cta} · shared by {story.author_name}
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noreferrer">
                <Button variant="outline" data-testid="public-share-facebook"><FacebookLogo size={16} weight="fill" className="mr-1.5" /> Facebook</Button>
              </a>
              <a href={`https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`} target="_blank" rel="noreferrer">
                <Button variant="outline" data-testid="public-share-whatsapp"><WhatsappLogo size={16} weight="fill" className="mr-1.5" /> WhatsApp</Button>
              </a>
              <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`} target="_blank" rel="noreferrer">
                <Button variant="outline" data-testid="public-share-x"><XLogo size={16} weight="fill" className="mr-1.5" /> X</Button>
              </a>
              <Button
                variant="outline"
                data-testid="public-share-instagram"
                onClick={() => {
                  navigator.clipboard?.writeText(`${text}\n${url}`)?.catch(() => {});
                  window.open(`${API}/public/story-card/${token}`, "_blank");
                  toast.success("Caption copied and card opened — save it and post to Instagram");
                }}
              >
                <InstagramLogo size={16} weight="fill" className="mr-1.5" /> Instagram
              </Button>
              <Button
                variant="outline"
                data-testid="public-copy-caption"
                onClick={() => {
                  navigator.clipboard?.writeText(`${text}\n${url}`)?.catch(() => {});
                  toast.success("Caption and link copied");
                }}
              >
                <Copy size={16} className="mr-1.5" /> Copy
              </Button>
            </div>
            <a href="/" className="mt-8 block text-xs text-slate-500 underline">Explore Unity &amp; Utility</a>
          </>
        )}
      </div>
    </div>
  );
}
